import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { media } from 'legacyComponents/styled/styleUtils';

export const ToggleButton = ({
  buttons,
  activeButton,
  margin,
  handleClick,
}) => {
  const inlineButtons = [];
  // FIXME - replace with map
  // eslint-disable-next-line
  for (const [index, btn] of buttons.entries()) {
    inlineButtons.push(
      <Btn
        onClick={() => handleClick(btn[0])}
        key={btn[0]}
        first={index === 0}
        last={index + 1 === buttons.length}
        active={btn[0] === activeButton}
      >
        {btn[1]}
      </Btn>,
    );
  }
  return <Wrapper margin={margin}>{inlineButtons}</Wrapper>;
};

const Wrapper = styled.div`
  display: block;
  margin: ${props => (props.margin ? props.margin : '0')};
  ${media.s`
    display: none;
  `}
`;

const Btn = styled.button`
  display: inline-block;
  height: 32px;
  font-size: 0.8125em;
  font-weight: 400;
  padding: ${props =>
    props.first ? '0 16px' : props.last ? '0 16px' : '0 16px'};
  background-color: ${props =>
    props.active ? props.theme.color.primary : props.theme.color.wfWhite};
  color: ${props =>
    props.active ? props.theme.color.wfWhite : props.theme.color.primary};
  border: 1px solid ${props => props.theme.color.primary};
  border-left: ${props =>
    !props.first ? 'none' : `1px solid ${props.theme.color.primary}`};
  border-radius: ${props =>
    props.first ? '20px 0 0 20px' : props.last ? '0 20px 20px 0' : '0'};
  cursor: pointer;
`;

ToggleButton.propTypes = {
  buttons: PropTypes.array,
  activeButton: PropTypes.string,
  margin: PropTypes.string,
  handleClick: PropTypes.func,
};
